"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useOutsideMouseEvent = void 0;
var _react = require("react");
var ROOT_ELEMENT_DEFAULT_ID = 'root';
var useOutsideMouseEvent = function useOutsideMouseEvent(eventType, refsArray, callback) {
  var config = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var options = config.options,
    _config$rootElementId = config.rootElementId,
    rootElementId = _config$rootElementId === void 0 ? ROOT_ELEMENT_DEFAULT_ID : _config$rootElementId;
  var handleEventOutside = function handleEventOutside(event) {
    var triggerCallback = true;
    refsArray.forEach(function (ref) {
      var _ref$current;
      if (ref !== null && ref !== void 0 && (_ref$current = ref.current) !== null && _ref$current !== void 0 && _ref$current.contains(event.target)) {
        triggerCallback = false;
      }
    });
    triggerCallback && (callback === null || callback === void 0 ? void 0 : callback());
  };
  (0, _react.useEffect)(function () {
    var rootElement = document.getElementById(rootElementId) || document;
    rootElement.addEventListener(eventType, handleEventOutside, options);
    return function () {
      rootElement.removeEventListener(eventType, handleEventOutside, options);
    };
  });
};
exports.useOutsideMouseEvent = useOutsideMouseEvent;